import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { BuildingModelWithLocationAndCounts } from '@/api/models/building';
import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_GetAll_Building = {
  location_id?: Id;
};

export type ApiResponse_GetAll_Building = Array<BuildingModelWithLocationAndCounts>;

const METHOD = 'GET';
const ENDPOINT = 'building/all';
export const QUERY_KEY = (params?: ApiRequest_GetAll_Building) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetAllBuildings = (params?: ApiRequest_GetAll_Building, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      try {
        const data = await handleApiCall<ApiResponse_GetAll_Building, ApiRequest_GetAll_Building>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {}),
          params
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch buildings.', { variant: 'error' });

        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
